import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteTabelaTributaria } from '../service';
import {
  DELETE_TABELA_TRIBUTARIA,
  DELETE_TABELA_TRIBUTARIA_PENDING,
  DELETE_TABELA_TRIBUTARIA_SUCCESS,
  DELETE_TABELA_TRIBUTARIA_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteTabelaTributaria(action) {
  yield put({ type: DELETE_TABELA_TRIBUTARIA_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.TABELA_TRIBUTARIA_EXCLUIR);
  
  try {
    const a = yield call(deleteTabelaTributaria, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_TABELA_TRIBUTARIA_SUCCESS, id: action.id });
  
    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });
  } catch (_) {
    yield put({ type: DELETE_TABELA_TRIBUTARIA_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se a tabela não possuí lançamentos vinculados e tente novamente...');
  }
}

export default function* watchDeleteTabelaTributaria() {
  yield takeLatest(DELETE_TABELA_TRIBUTARIA, sagaDeleteTabelaTributaria)
}
